"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementProvenanceSchema = void 0;
const z = require("zod");
exports.StatementProvenanceSchema = z.object({
    statementId: z.string(),
    adjudicatedByUserId: z.string(),
    adjudicatedAt: z.date(),
    comment: z.string().nullable(),
    planId: z.string().nullable(),
});
//# sourceMappingURL=service-contracts.js.map